import GuestLayout from "@/layouts/GuestLayout.vue";
import LoginComponent from "@/views/auth/LoginComponent.vue";
import RegisterComponent from "@/views/auth/RegisterComponent.vue";
import RecoveryPasswordComponent from "@/views/auth/RecoveryPasswordComponent.vue";
import HomeComponent from "@/views/app/HomeComponent.vue";
import { createRouter, createWebHistory } from "vue-router";
import AppLayout from "@/layouts/AppLayout.vue";
import CreditDetailComponent from "@/views/app/CreditDetailComponent.vue";
import TransactionsComponent from "@/views/app/TransactionsComponent.vue";
import ProductsComponent from "@/views/app/ProductsComponent.vue";
import SettingsComponent from "@/views/app/SettingsComponent.vue";
import ContributionDetailComponent from "@/views/app/ContributionDetailComponent.vue";
import SavingDetailComponent from "@/views/app/SavingDetailComponent.vue";
import NotFoundComponent from "@/views/errors/NotFoundComponent.vue";
import { useAuthStore } from "@/store/auth.store";

const routes = [
  {
    path: "/",
    component: GuestLayout,
    redirect: "/login",
    children: [
      {
        path: "login",
        name: "login",
        component: LoginComponent,
      },
      {
        path: "register",
        name: "register",
        component: RegisterComponent,
      },
      {
        path: "recovery-password",
        name: "recovery-password",
        component: RecoveryPasswordComponent,
      },
    ],
  },
  {
    path: "/app",
    component: AppLayout,
    meta: { requiresAuth: true },
    children: [
      {
        path: "home",
        name: "home",
        component: HomeComponent,
      },
      {
        path: "credit-detail",
        name: "credit-detail",
        component: CreditDetailComponent,
      },
      {
        path: "contribution-detail",
        name: "contribution-detail",
        component: ContributionDetailComponent,
      },
      {
        path: "saving-detail",
        name: "saving-detail",
        component: SavingDetailComponent,
      },
      {
        path: "transactions",
        name: "transactions",
        component: TransactionsComponent,
      },
      {
        path: "products",
        name: "products",
        component: ProductsComponent,
      },
      {
        path: "settings",
        name: "settings",
        component: SettingsComponent,
      },
    ],
  },
  // Ruta comodín para manejar 404
  {
    path: "/:catchAll(.*)",
    name: "not-found",
    component: NotFoundComponent,
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL || "localhost"),
  routes,
});

// Navigation guard para proteger rutas que requieren autenticación
router.beforeEach((to, from, next) => {
  const authStore = useAuthStore();

  // Verificar si la ruta requiere autenticación
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    // Verificar si el usuario está autenticado
    if (!authStore.getIsLoggedIn) {
      // Si no está autenticado, redirigir al login
      next({ name: "login" });
    } else {
      // Validar la última interacción para verificar si la sesión sigue activa
      if (!authStore.updateLastInteraction()) {
        // Si la sesión expiró, redirigir al login
        next({ name: "login" });
      } else {
        // Si está autenticado y la sesión es válida, permitir el acceso
        next();
      }
    }
  } else {
    // Si la ruta no requiere autenticación, permitir el acceso
    // Pero si ya está autenticado y trata de ir al login, redirigir a home
    if (
      authStore.getIsLoggedIn &&
      (to.name === "login" ||
        to.name === "register" ||
        to.name === "recovery-password")
    ) {
      next({ name: "home" });
    } else {
      next();
    }
  }
});

export default router;
